import { render, staticRenderFns } from "./ClassPerformanceBatchDetail.vue?vue&type=template&id=1b9d78b0&scoped=true&"
import script from "./ClassPerformanceBatchDetail.vue?vue&type=script&lang=js&"
export * from "./ClassPerformanceBatchDetail.vue?vue&type=script&lang=js&"
import style0 from "./ClassPerformanceBatchDetail.vue?vue&type=style&index=0&id=1b9d78b0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b9d78b0",
  null
  
)

export default component.exports